import setPostMeasureOptionsCookie from '../../setPostMeasureOptionsCookie';
import getPLPUrl from '../../getPLPUrl';

export default itemId => (dispatch) => {
  dispatch(setPostMeasureOptionsCookie(itemId));
  window.location.href = dispatch(getPLPUrl(itemId));
};
